interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

export default function ErrorMessage({ message, onRetry }: ErrorMessageProps) {
  return (
    <div className="vintage-paper aged-paper p-6 shadow-lg text-center">
      <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 bg-red-100/50 rounded-full">
        <i className="ri-error-warning-line text-red-600 text-xl"></i>
      </div>
      
      <h3 className="font-headings text-lg text-sepia-900 mb-2">
        Error al cargar contenido
      </h3>
      
      <p className="text-sm text-sepia-700 mb-4 font-body">
        {message}
      </p>
      
      {onRetry && (
        <button 
          onClick={onRetry}
          className="vintage-paper-subtle text-sepia-900 hover:bg-sepia-200/70 px-4 py-2 text-sm font-ui transition-all duration-300 rounded-[15%] hover:shadow-md flex items-center gap-2 mx-auto"
        >
          <i className="ri-refresh-line"></i>
          Intentar de nuevo
        </button>
      )}
    </div>
  );
}